import type { BadgeProps as BadgeNewProps } from './Badge';
import type { BadgeKind, BadgeShape as OldBadgeShape } from './types.old';

export interface OldBadgeProps extends Omit<BadgeNewProps, 'variant' | 'shape' | 'leftIcon' | 'rightIcon'> {
  /** @deprecated variant를 대신 사용해주세요. */
  kind?: BadgeKind;
  shape?: OldBadgeShape;
  /** @deprecated leftIcon을 대신 사용해주세요. */
  startIcon?: BadgeNewProps['leftIcon'];
  /** @deprecated rightIcon을 대신 사용해주세요. */
  endIcon?: BadgeNewProps['rightIcon'];
}

export function convertOldBadgeProps(props: OldBadgeProps): BadgeNewProps {
  const { kind, shape, startIcon, endIcon, ...restProps } = props;

  return {
    ...restProps,
    variant: kind === 'fill' ? 'filled' : kind === 'outline' ? 'outlined' : undefined,
    shape: shape === 'rectangle' ? 'rounded' : shape,
    leftIcon: startIcon,
    rightIcon: endIcon,
  };
}
